import { useMutation } from '@tanstack/react-query';
import { apiError } from './api.js';
import { toast } from './useToast.js';

export function useApiMutation({ mutationFn, onSuccess, onError, successMessage, errorToast = true } = {}) {
  return useMutation({
    mutationFn,
    onSuccess: (data, vars, ctx) => {
      if (successMessage) toast.success(successMessage);
      if (onSuccess) onSuccess(data, vars, ctx);
    },
    onError: (err, vars, ctx) => {
      if (errorToast) toast.error(apiError(err));
      if (onError) onError(err, vars, ctx);
    }
  });
}
